import React, { Component } from "react";
import "../assets/css/Dashboard.css";
import StatField from "../component/StatField";
import BudgetOverview from "../component/BudgetOverview";
import BudgetTable from "../component/BudgetTable";
import search from "../assets/image/search-icon.png";
import "../assets/css/MainContainer.css";
/*import BarInfo from "../component/BarInfo";
import { Doughnut, Line, Chart, Bar } from "react-chartjs-2";
import CasesNumber from "../component/CasesNumber";
import CasesPercentage from "../component/CasesPercentage";*/

var closedCases = 54;
var workedCases = 27;
var passedCases = 19;

/*var doughnut1Options = {
  legend: {
    display: false
  },
  title: {
    display: true,
    position: "top",
    text: "Offene Fälle",
    fontColor: "#FFF",
    fontSize: 20
  },
  cutoutPercentage: 50,
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        //calculate the total of this data set
        var total = dataset.data.reduce(function(
          previousValue,
          currentValue,
          currentIndex,
          array
        ) {
          return previousValue + currentValue;
        });
        //get the current items value
        var currentValue = dataset.data[tooltipItem.index];
        var tag = tooltipItem.index === 0 ? "Erledigt" : "Offen";
        //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
        var precentage = Math.floor((currentValue / total) * 100 + 0.5);
        return tag + ": " + precentage + "%";
      }
    }
  }
};*/

/*var doughnut2Options = {
  legend: {
    display: false
  },
  title: {
    display: true,
    position: "top",
    text: "Abgeschlossene Fälle",
    fontColor: "#FFF",
    fontSize: 20
  },
  cutoutPercentage: 50,
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        //calculate the total of this data set
        var total = dataset.data.reduce(function(
          previousValue,
          currentValue,
          currentIndex,
          array
        ) {
          return previousValue + currentValue;
        });
        //get the current items value
        var currentValue = dataset.data[tooltipItem.index];
        var tag = tooltipItem.index === 0 ? "Erledigt" : "Offen";
        //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
        var precentage = Math.floor((currentValue / total) * 100 + 0.5);
        return tag + ": " + precentage + "%";
      }
    }
  }
};*/

/*var doughnut3Options = {
  legend: {
    display: false
  },
  title: {
    display: true,
    position: "top",
    text: "Übergebene Fälle",
    fontColor: "#FFF",
    fontSize: 20
  },
  cutoutPercentage: 50,
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        //calculate the total of this data set
        var total = dataset.data.reduce(function(
          previousValue,
          currentValue,
          currentIndex,
          array
        ) {
          return previousValue + currentValue;
        });
        //get the current items value
        var currentValue = dataset.data[tooltipItem.index];
        var tag = tooltipItem.index === 0 ? "Erledigt" : "Offen";
        //calculate the precentage based on the total and current item, also this does a rough rounding to give a whole number
        var precentage = Math.floor((currentValue / total) * 100 + 0.5);
        return tag + ": " + precentage + "%";
      }
    }
  }
};*/

/*const barOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          color: "rgba(255,255,255,1)"
        },
        barPercentage: 0.4,
        ticks: {
          fontColor: "white"
        },
        gridLines: {
          color: "rgba(0,0,0,0)"
        }
      }
    ],
    yAxes: [
      {
        stacked: true,
        gridLines: {
          color: "rgba(255,255,255,1)"
        },
        ticks: {
          fontColor: "white",
          stepSize: 250,
          callback: function(label, index, labels) {
            return label / 10 + "T €";
          }
        }
      }
    ]
  },
  legend: {
    display: false
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem) {
        return tooltipItem.yLabel;
      }
    }
  }
};*/

export default class RoutineScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cases: 23,
      modal: false,
      dataOne: {
        display: false,
        labels: ["Erledigt", "Offen"],
        datasets: [
          {
            data: [closedCases, 100 - closedCases],
            backgroundColor: ["#e3d917", "#5550"],
            hoverBackgroundColor: ["#e3d917EE", "#5555"],
            borderColor: ["#0000", "#5550"],
            hoverBorderColor: ["#0000", "#5555"]
          }
        ]
      },
      dataTwo: {
        labels: ["Erledigt", "Offen"],
        datasets: [
          {
            data: [workedCases, 100 - workedCases],
            backgroundColor: ["#ebab10", "#5550"],
            hoverBackgroundColor: ["#ebab10EE", "#5550"],
            borderColor: ["#26c71600", "#5550"],
            hoverBorderColor: ["#0000", "#5550"]
          }
        ]
      },
      dataThree: {
        labels: ["Erledigt", "Offen"],
        datasets: [
          {
            data: [passedCases, 100 - passedCases],
            backgroundColor: ["#eb1010", "#5550"],
            hoverBackgroundColor: ["#eb1010EE", "#5550"],
            borderColor: ["#26c71600", "#5550"],
            hoverBorderColor: ["#0000", "#5550"]
          }
        ]
      },
      dataBar: {
        labels: [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember"
        ],
        backgroundColor: "#0000",
        color: "white",
        datasets: [
          {
            data: [
              100,
              90,
              120,
              150,
              200,
              150,
              100,
              90,
              120,
              150,
              200,
              150,
              160
            ],
            backgroundColor: [
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff",
              "#004fff"
            ]
          },
          {
            data: [120, 120, 130, 160, 220, 170, 120, 120, 130, 160, 220, 170],
            backgroundColor: [
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55",
              "#004fff55"
            ]
          },
          {
            data: [150, 100, 140, 165, 210, 225, 150, 100, 140, 165, 210, 225],
            backgroundColor: [
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853",
              "#00C853"
            ]
          },
          {
            data: [160, 110, 150, 20, 70, 9, 160, 110, 150, 20, 70, 90],
            backgroundColor: [
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355",
              "#00C85355"
            ]
          },
          {
            backgroundColor: [
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03",
              "#76FF03"
            ],
            data: [250, 110, 164, 180, 220, 300, 250, 110, 164, 180, 220, 300]
          },
          {
            backgroundColor: [
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355",
              "#76FF0355"
            ],
            data: [250, 110, 164, 180, 220, 300, 250, 110, 164, 180, 220, 300]
          }
        ]
      },
      tableObject: {
        tableStructure: [
          { name: "Haushaltsstelle im Workflow", id: "haushalt" },
          { name: "Budget", id: "budget" },
          { name: "gebunden", id: "gebunden" },
          { name: "ausgezahlt", id: "ausgezahlt" },
          { name: "verf. Mittel", id: "mittelver" },
          { name: "vorgem. Mittel", id: "mittelvor" },
          { name: "freie Mittel", id: "mittelfre" },
          { name: "Rechnungen", id: "rechnung" }
        ],
        tableData: [
          {
            entry: 0,
            entryData: [
              createEntryDataObject("haushalt", "0815"),
              createEntryDataObject("budget", 61283),
              createEntryDataObject("gebunden", 12333),
              createEntryDataObject("ausgezahlt", 9900),
              createEntryDataObject("mittelver", 81238),
              createEntryDataObject("mittelvor", 31),
              createEntryDataObject("mittelfre", 123.32),
              createEntryDataObject("rechnung", "Rechnung 100072")
            ]
          },
          {
            entry: 1,
            entryData: [
              createEntryDataObject("haushalt", "0816"),
              createEntryDataObject("budget", 3333),
              createEntryDataObject("gebunden", 3123),
              createEntryDataObject("ausgezahlt", 88913),
              createEntryDataObject("mittelver", 3893.2),
              createEntryDataObject("mittelvor", 3823.12),
              createEntryDataObject("mittelfre", 3.14),
              createEntryDataObject("rechnung", "Rechnung 100073")
            ]
          },
          {
            entry: 2,
            entryData: [
              createEntryDataObject("haushalt", "0817"),
              createEntryDataObject("budget", 3333),
              createEntryDataObject("gebunden", 55212),
              createEntryDataObject("ausgezahlt", 1212),
              createEntryDataObject("mittelver", 41.22),
              createEntryDataObject("mittelvor", 5325),
              createEntryDataObject("mittelfre", 3),
              createEntryDataObject("rechnung", "Rechnung 100074")
            ]
          },
          {
            entry: 3,
            entryData: [
              createEntryDataObject("haushalt", "0818"),
              createEntryDataObject("budget", 3333),
              createEntryDataObject("gebunden", 3123),
              createEntryDataObject("ausgezahlt", 88913),
              createEntryDataObject("mittelver", 3893.2),
              createEntryDataObject("mittelvor", 3823.12),
              createEntryDataObject("mittelfre", 3.14),
              createEntryDataObject("rechnung", "Rechnung 100075")
            ]
          },
          {
            entry: 4,
            entryData: [
              createEntryDataObject("haushalt", "0819"),
              createEntryDataObject("budget", 245433),
              createEntryDataObject("gebunden", 3123),
              createEntryDataObject("ausgezahlt", 88913),
              createEntryDataObject("mittelver", 5255),
              createEntryDataObject("mittelvor", 38345),
              createEntryDataObject("mittelfre", 3.14),
              createEntryDataObject("rechnung", "Rechnung 200076")
            ]
          },
          {
            entry: 5,
            entryData: [
              createEntryDataObject("haushalt", "0820"),
              createEntryDataObject("budget", 44444),
              createEntryDataObject("gebunden", 44),
              createEntryDataObject("ausgezahlt", 44),
              createEntryDataObject("mittelver", 4.24),
              createEntryDataObject("mittelvor", 44.44),
              createEntryDataObject("mittelfre", 4444.44),
              createEntryDataObject("rechnung", "Rechnung 400044")
            ]
          },
          {
            entry: 9,
            entryData: [
              createEntryDataObject("haushalt", "0821"),
              createEntryDataObject("budget", 124221.95),
              createEntryDataObject("gebunden", 111.63),
              createEntryDataObject("ausgezahlt", 54537.2),
              createEntryDataObject("mittelver", 23.92),
              createEntryDataObject("mittelvor", 664.05),
              createEntryDataObject("mittelfre", 334.77),
              createEntryDataObject("rechnung", "Rechnung 400048")
            ]
          },
          {
            entry: 9,
            entryData: [
              createEntryDataObject("haushalt", "0822"),
              createEntryDataObject("budget", 10000.65),
              createEntryDataObject("gebunden", 9000.07),
              createEntryDataObject("ausgezahlt", 10.84),
              createEntryDataObject("mittelver", 1250.34),
              createEntryDataObject("mittelvor", 1110.36),
              createEntryDataObject("mittelfre", 2220.05),
              createEntryDataObject("rechnung", "Rechnung 400048")
            ]
          },
          {
            entry: 9,
            entryData: [
              createEntryDataObject("haushalt", "0823"),
              createEntryDataObject("budget", 1222.45),
              createEntryDataObject("gebunden", 120.05),
              createEntryDataObject("ausgezahlt", 10.64),
              createEntryDataObject("mittelver", 20.48),
              createEntryDataObject("mittelvor", 20.86),
              createEntryDataObject("mittelfre", 20.31),
              createEntryDataObject("rechnung", "Rechnung 400048")
            ]
          },
          {
            entry: 9,
            entryData: [
              createEntryDataObject("haushalt", "0824"),
              createEntryDataObject("budget", 88880.28),
              createEntryDataObject("gebunden", 4450.25),
              createEntryDataObject("ausgezahlt", 85580.48),
              createEntryDataObject("mittelver", 5550.76),
              createEntryDataObject("mittelvor", 840.82),
              createEntryDataObject("mittelfre", 85480.55),
              createEntryDataObject("rechnung", "Rechnung 400048")
            ]
          }
        ]
      }
    };
  }

  componentDidMount() {
    // let bar = this.refs.bar;
    // console.log(bar.chartInstance.ctx);
    // bar.chartInstance.ctx.fillStyle = 'rgba(0,0,0,0)'
    // console.log(bar.chartInstance.ctx)
  }

  render() {
    return (
      <div className="dashboard dash">
        <div
          className="quarterDivider"
          style={{
            display: "flex",
            width: "100%",
            height: "85%",
            flexDirection: "column"
          }}
        >
          <div
            className="topDivs"
            style={{ display: "flex", width: "100%", height: "50%" }}
          >
            <div
              className="topleftQuarter"
              style={{
                display: "flex",
                width: "50%",
                height: "100%",
                alignSelf: "flex-start",
                flexDirection: "column"
              }}
            >
              <div className="stat" style={{ width: "calc(100%) " }}>
                <p>Übersicht meiner Rechnungen</p>
              </div>
              <div
                className="upperHalf"
                style={{
                  display: "flex",
                  width: "100%",
                  height: "50%",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 25
                }}
              >
                <div
                  className="statField"
                  style={{ width: "33%", height: "99%" }}
                >
                  <StatField title="Gesamt" marked={false}>
                    21
                  </StatField>
                </div>
                <div
                  className="statField"
                  style={{
                    marginLeft: "1px",
                    marginRight: "1px",
                    width: "33%",
                    height: "99%"
                  }}
                >
                  <StatField title="Kritisch">2</StatField>
                </div>
                <div
                  className="statField"
                  style={{ width: "33%", height: "99%" }}
                >
                  <StatField title="Fällig">3</StatField>
                </div>
              </div>
              <div className="spacer"></div>
              <div
                className="lowerHalf"
                style={{
                  display: "flex",
                  width: "100%",
                  height: "50%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <div
                  className="statField"
                  style={{ width: "33%", height: "99%" }}
                >
                  <StatField title="Neu">7</StatField>
                </div>
                <div
                  className="statField"
                  style={{
                    marginLeft: "1px",
                    marginRight: "1px",
                    width: "33%",
                    height: "99%"
                  }}
                >
                  <StatField title="Wiedervorlagen">3</StatField>
                </div>
                <div
                  className="statField"
                  style={{ width: "33%", height: "99%" }}
                >
                  <StatField title="Unbearbeitet">6</StatField>
                </div>
              </div>
            </div>
            <div
              className="topRightQuarter"
              style={{
                display: "flex",
                width: "65%",
                height: "100%",
                flexDirection: "row",
                alignSelf: "flex-end",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: 40
              }}
            >
              <div
                className="upperHalf"
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  flexDirection: "column"
                }}
              >
                <div className="stat">
                  <p>Meine Budgetstand</p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    width: "100%",
                    marginTop: "1.1em",
                    marginLeft: "1em"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flexBasis: "100%",
                      flex: "1"
                    }}
                  >
                    <BudgetOverview
                      amount={450000}
                      title={"Budget"}
                    ></BudgetOverview>
                    <BudgetOverview
                      amount={80000}
                      title={"gebunden"}
                    ></BudgetOverview>
                    <BudgetOverview
                      amount={20000}
                      title={"ausgezahlt"}
                    ></BudgetOverview>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flexBasis: "100%",
                      flex: "1",
                      marginTop: "3.5em"
                    }}
                  >
                    <BudgetOverview
                      amount={370000}
                      title={"verfügbare Mittel"}
                    ></BudgetOverview>
                    <BudgetOverview
                      amount={280000}
                      title={"vorgemerkte Mittel"}
                    ></BudgetOverview>
                    <BudgetOverview
                      amount={90000}
                      title={"freie Mittel"}
                    ></BudgetOverview>
                  </div>
                </div>
                {/* the following are pie charts
                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 40, }}>
                  <div style={{ width: '33%', height: '99%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'flex-end', float: 'right' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 'auto', height: 'auto', alignItems: 'center', justifyContent: 'center' }}>
                      <Doughnut data={() => { return this.state.dataOne }}
                        borderColor='#FFFF'
                        options={doughnut1Options}
                        height={200}
                        elevation={2} />
                      <p style={{ position: 'absolute', textAlign: 'center', marginTop: -25, marginLeft: 2, fontSize: '22px', fontWeight: '600', letterSpacing: '2px', color: 'white' }}>{this.state.dataOne.datasets[0].data[0]}%</p>
                      <div style={{ backgroundColor: '#0008', color: 'white', marginTop: 15, width: 150, height: 20, paddingTop: 5, paddingBottom: 5, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <p style={{ letterSpacing: '2px' }}>20 Fälle</p>
                      </div>
                      <CasesPercentage percentage={this.state.dataOne.datasets[0].data[0]} color='#e3d917' action='bearbeitet' />

                    </div>
                  </div>
                  <div style={{ width: '33%', height: '99%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 'auto', height: 'auto', alignItems: 'center', justifyContent: 'center', }}>
                      <Doughnut data={this.state.dataTwo}
                        borderColor='#FFFF'
                        options={doughnut2Options}
                        height={200}
                        elevation={2} />
                      <p style={{ position: 'absolute', textAlign: 'center', marginTop: -20, marginLeft: 2, fontSize: '22px', fontWeight: '600', letterSpacing: '2px', color: 'white' }}>{this.state.dataTwo.datasets[0].data[0]}%</p>
                      <div style={{ backgroundColor: '#0008', color: 'white', marginTop: 15, width: 150, height: 20, paddingTop: 5, paddingBottom: 5, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <p style={{ letterSpacing: '2px' }}>10 Fälle</p>
                      </div>
                      <CasesPercentage percentage={this.state.dataTwo.datasets[0].data[0]} color='#ebab10' action='abgeschlossen' />
                    </div>
                  </div>
                  <div style={{ width: '33%', height: '99%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 'auto', height: 'auto', alignItems: 'center', justifyContent: 'center', }}>
                      <Doughnut data={this.state.dataThree}
                        borderColor='#FFFF'
                        options={doughnut3Options}
                        height={200}
                        elevation={2} />
                      <p style={{ position: 'absolute', textAlign: 'center', marginTop: -20, marginLeft: 2, fontSize: '22px', fontWeight: '600', letterSpacing: '2px', color: 'white' }}>{this.state.dataThree.datasets[0].data[0]}%</p>
                      <div style={{ backgroundColor: '#0008', color: 'white', marginTop: 15, width: 150, height: 20, paddingTop: 5, paddingBottom: 5, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                        <p style={{ letterSpacing: '2px' }}>7 Fälle</p>
                      </div>
                      <CasesPercentage percentage={this.state.dataThree.datasets[0].data[0]} color='#eb1010' action='abgeschlossen' />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div
            className="bottomDivs"
            style={{
              display: "flex",
              width: "100%",
              height: "50%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 100,
              float: "bottom"
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <div className="stat">
                <p>Haushaltsstellen Übersicht</p>
              </div>
              <div className="logo">
                <p style={{ color: "white", marginRight: "0px" }}>
                  Haushaltsstelle
                </p>
                <img src={search} className="searchIcon" alt="liim" />
                <input type="text" name="fname" placeholder="Suche" />
              </div>
              {/* cm2 <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', marginTop: 15 }}> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  width: "100%",
                  marginTop: "1.1em",
                  marginLeft: "1em"
                }}
              >
                <BudgetTable
                  tableStructure={this.state.tableObject.tableStructure}
                  tableData={this.state.tableObject.tableData}
                />
              </div>
              {/* a graph / bar with some data
                <div style={{ display: 'inline', width: '80%', height: '100%', }}>
                  <Bar data={this.state.dataBar}
                    width={80}
                    height={20}
                    options={barOptions}
                    color='white'
                    ref='bar'
                  />
                </div> */}
              {/* Overview display bar infos
                <div style={{ display: 'flex', width: '20%', height: '100%', flexDirection: 'column', marginLeft: 30, marginTop: 35, justifyContent: 'center', alignitems: 'center' }}>
                  <BarInfo title='Tilgungsanteil' content='97%' />
                  <BarInfo title='Gesamtsumme Tilgung' content='2.123.039,67€' />
                  <BarInfo title='Gesamtsumme Inkasso' content='2.188.700,69€' />
                </div> */}
              {/* cm2 </div> */}
            </div>
          </div>
        </div>

        {/*
      <div className='dashboard dash'>
        <div className='dashContainer dash'>
          <table style={{width:'100%',height:'100%'}}>
            <tr>
              <td>
                <div className='column dash' >
                  <div className='statContainer'>
                    <div className='statRow'>
                      <div className='statField'>
                        <div className='statt dark'>
                          <h1>37</h1>
                          <p>Gesamt</p>
                        </div>
                      </div>
                      <div className='statField'>
                        <div className='statt'>
                          <h1>7</h1>
                          <p>Kritisch</p>
                        </div>
                      </div>
                      <div className='statField'>
                        <div className='statt'>
                          <h1>5</h1>
                          <p>Besonders</p>
                        </div>
                      </div>
                    </div>
                    <div className='statRow'>
                      <div className='statField'>
                        <div className='statt'>
                          <h1>9</h1>
                          <p>Neu</p>
                        </div>
                      </div>
                      <div className='statField'>
                        <div className='statt'>
                          <h1>3</h1>
                          <p>Wiedervorlage</p>
                        </div>
                      </div>
                      <div className='statField'>
                        <div className='statt'>
                          <h1>12</h1>
                          <p>Unbearbeitet</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div className='column dash'>
                    <Bar data={this.state.dataBar}
                    width={100}
                    height={30}
                    options={barOptions}
                    />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div className='half' style={{width: '30%'}}>
                  <div className='stat' >
                    <p>Ihre Effizienz</p>
                    <div className='counter' style={{border: 'none'}}>
                      ›
                    </div>
                  </div>
                  <div className='graphRow'>
                    <div className='graphColumn'>
                      <Doughnut data={this.state.dataOne}
                        width={200}
                        height={200}
                        borderColor='#FFFF'
                        options={doughnut1Options}
                        />
                      <p style={{color:'white',position:'absolute',marginTop:-100,marginLeft:68,fontSize:35}}>{this.state.dataOne.datasets[0].data[0]}%</p>
                      <CasesNumber cases={this.state.cases} />
                      <CasesPercentage percentage={this.state.dataOne.datasets[0].data[0]}/>
                    </div>
                    <div className='graphColumn' style={{paddingLeft:'25px'}}>
                      <Doughnut data={this.state.dataTwo}
                        width={200}
                        height={200}
                        borderColor='#FFFF'
                        options={doughnut2Options}
                        elevation={2}/>
                        <p style={{color:'white',position:'absolute',marginTop:-98,marginLeft:68,fontSize:35}}>{this.state.dataTwo.datasets[0].data[0]}%</p>
                        <CasesNumber cases={this.state.cases} />
                        <CasesPercentage percentage={this.state.dataTwo.datasets[0].data[0]} color='#42d29a'/>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div className='half' style={{width: '70%'}}>
                  <div className='stat' >
                    <p>Monetäre KPI</p>
                    <div className='counter' style={{border: 'none'}}>
                      ›
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
        */}
      </div>
    );
  }
}
function createEntryDataObject(fieldName, fieldValue) {
  return [fieldName, fieldValue];
  // return { field: fieldName, data: fieldValue }
}



// WEBPACK FOOTER //
// ./src/screens/Dashboard.js